//@ts-check
import createBatchAction from '@/common/lib/create-batch-action';
import { showLoading, hideLoading } from '@/common/components/kf-loader';
import { STATUS_FAILURE_NO_TARGET } from '@/common/constants';
import { errorHandler } from '../ajax';
import { updateResult } from '../result/result.action';
import { openFailedDialog, openSuccessDialog } from '@/common/components/kf-dialog';

export const changeRequestRequest = createBatchAction('@@password/CHANGE_REQUEST_REQUEST', () => [showLoading()]);
export const changeRequestSuccess = createBatchAction('@@password/CHANGE_REQUEST_SUCCESS', () => [
  hideLoading(),
  updateResult('メールアドレスにパスワード新規設定用のメールを送信しました。')
]);
export const changeRequestFailure = createBatchAction('@@password/CHANGE_REQUEST_FAILURE', (err) => [
  hideLoading(),
  err.status == STATUS_FAILURE_NO_TARGET ? openFailedDialog('失敗しました。\nメールアドレスが存在しません。') : errorHandler(err),
]);

export const changeCheckRequest = createBatchAction('@@password/CHANGE_CHECK_REQUEST', () => [showLoading()]);
export const changeCheckSuccess = createBatchAction('@@password/CHANGE_CHECK_SUCCESS', () => [hideLoading()]);
export const changeCheckFailure = createBatchAction('@@password/CHANGE_CHECK_FAILURE', (err) => [
  hideLoading(),
  err.status == STATUS_FAILURE_NO_TARGET ? updateResult('失敗しました。urlが使用済みです。') : errorHandler(err),
]);

export const changeRequest = createBatchAction('@@password/CHANGE_REQUEST', () => [showLoading()]);
export const changeSuccess = createBatchAction('@@password/CHANGE_SUCCESS', () => [hideLoading(), openSuccessDialog('パスワードを変更しました。')]);
export const changeFailure = createBatchAction('@@password/CHANGE_FAILURE', (err) => [
  hideLoading(),
  err.status == STATUS_FAILURE_NO_TARGET ? updateResult('パスワードの変更に失敗しました。urlが使用済みです。') : errorHandler(err),
]);